import script from "./SupervisaoCancelar.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisaoCancelar.vue?vue&type=script&setup=true&lang=js"

import "./SupervisaoCancelar.vue?vue&type=style&index=0&id=7a1ed0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a1ed0b2"]])

export default __exports__